import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForceUpgradeService {

  constructor(private http: HttpClient) { }

  createAppRelease(requestData: any): Observable<any> {
    const url = `${environment.host}/app-release`;
    return this.http.post(url, requestData);
  }

  getAllAppReleases(platformType: string): Observable<any> {
    const url = `${environment.host}/app-release/${platformType}`;
    return this.http.get(url);
  }

  updateAppRelease(updateData: any, platformType: string, releaseId: string): Observable<any> {
    const url = `${environment.host}/app-release/${platformType}/${releaseId}`;
    return this.http.patch(url, updateData);

  }

  deleteAppRelease(releaseId: string, platformType: string): Observable<any> {
    const url = `${environment.host}/app-release/${platformType}/${releaseId}`;
    return this.http.delete(url);
  }
}
